import * as api from '@/api/skPlan'
import * as TYPES from './type';

export default {
  //授课计划
  async getPlanList({ commit, state }, { paramets, cb, cbParamets = {} }) {
    const result = await api.reqPlanList(paramets)
    commit(TYPES.PLAN_LIST, { result })
    cb && cb({...cbParamets})
  },
  async postAddPlan({ commit, state }, { paramets, cb }) {
    const result = await api.reqAddPlan(paramets)
    commit(TYPES.PLAN_INFO, { result, type: 'add' })
    cb && cb()
  },
  async putUpdatePlan({ commit, state }, { paramets, cb }) {
    const result = await api.reqUpdatePlan(paramets)
    commit(TYPES.PLAN_INFO, { result, type: 'edit' })
    cb && cb()
  },
  async getCourseTreeList({ commit, state }, { paramets, cb }) {
    const result = await api.reqCourseTreeList(paramets)
    //console.log(result)
    commit(TYPES.PLAN_INFO, { result, type: 'treeList' })
    cb && cb()
  },
  async getTeamsTreeList({ commit, state }, { paramets, cb }) {
    const result = await api.reqTeamsTreeList(paramets)
    //console.log(result)
    commit(TYPES.PLAN_INFO, { result, type: 'teamsList' })
    cb && cb()
  },
  async getMajorList({ commit, state }, cb) {
    const result = await api.reqMajorList()
    commit(TYPES.PLAN_INFO, { result, type: 'marjor' })
    cb && cb()
  },
  async getTeamListByMajorId({ commit, state }, { paramets, cb }) {
    const result = await api.reqTeamListByMajorId(paramets)
    commit(TYPES.PLAN_INFO, { result, type: 'team' })
    cb && cb()
  },
  async getPlanById({ commit, state }, { paramets, cb }) {
    const result = await api.reqPlanById(paramets)
    commit(TYPES.PLAN_INFO, { result, type: 'detail' })
    cb && cb()
  },
  async getPlanCatalogById({ commit, state }, { paramets, cb }) {
    const result = await api.reqPlanCatalogById(paramets)
    commit(TYPES.PLAN_INFO, { result, type: 'detailCatalog' })
    cb && cb()
  },
  async getPlanClassById({ commit, state }, { paramets, cb }) {
    const result = await api.reqPlanClassById(paramets)
    commit(TYPES.PLAN_INFO, { result, type: 'detailClass' })
    cb && cb()
  },
  async getPlanTeamById({ commit, state }, { paramets, cb }) {
    const result = await api.reqPlanTeamById(paramets)
    commit(TYPES.PLAN_INFO, { result, type: 'detailTeam' })
    cb && cb()
  },
  async deletePlanById({ commit }, { paramets, cb }) {
    const result = await api.reqDeleteById(paramets)
    commit(TYPES.COURSE_DELETE,result)
    cb && cb()
  },
  async addXzClass({ commit }, { paramets, cb }) {
    const result = await api.reqAddXzClass(paramets)
    commit(TYPES.ADD_XZ_CLASS,result)
    cb && cb()
  },
  async getViewCourseTree({ commit }, { paramets, cb }) {
    const result = await api.reqViewCourseTree(paramets)
    commit(TYPES.VIEW_COURSE_TREE,result)
    cb && cb()
  },
}
